(function () {
    'use strict';

    angular
        .module('skillsApp')
        .directive('identitySearch', identitySearch);

    function identitySearch() {
        return {
            templateUrl: '/app/directives/identity-search.tpl.html',
            scope: {
                searchForUsers: '=',
                searchForGroups: '=',
                identitySelected: '&',
                filterIdStrings: '=',
                showUserStatusFilter: '='
            },
            controller: IdentitySearchController,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function IdentitySearchController($scope, $q, $window, $timeout, logger, config, userService) {
        var vm = this;

        var searchForUsers = vm.searchForUsers === undefined ? true : vm.searchForUsers;
        var searchForGroups = vm.searchForGroups === undefined ? false : vm.searchForGroups;
        var type = 0; // none

        vm.userStatusFilter = 'enabled';

        if (searchForUsers) type += 1; // users
        if (searchForGroups) type += 2; // groups

        if (type === 1) {
            vm.placeholder = 'search_for_users';
        } else if (type === 2) {
            vm.placeholder = 'search_for_groups';
        } else if (type === 3) {
            vm.placeholder = 'search_for_users_and/or_groups';
        }

        vm.changeDomain = changeDomain;
        vm.onSelectIdentity = onSelectIdentity;
        vm.search = search;
        vm.setUserStatusFilter = setUserStatusFilter;

        userService.getDomains(true).then(domains => {

            var domainId = $window.localStorage.getItem("search-domain-id");
            var domain = null;

            if (domainId) {
                domain = _.find(domains, (domain) => { return domain.id === domainId; });
            }

            if (!domain) {
                $window.localStorage.removeItem("search-domain-id");
                domainId = config.settings.user.idString.substring(2, 38);
                domain = _.find(domains, (domain) => { return domain.id === domainId; });
            }

            $timeout(function () {
                vm.domains = domains;
                vm.domain = domain;
            }, 0);
        });
       
        function changeDomain(domain, ev) {
            ev.preventDefault();
            $window.localStorage.setItem("search-domain-id", domain.id);
            vm.domain = domain;
        }

        function onSelectIdentity() {
            var identity = angular.copy(vm.identity);
            if (typeof vm.identitySelected() === 'function') {
                vm.identitySelected()(identity);
            }
            vm.identity = null;
        }

        function search(find) {
            if (!find) return null;

            vm.isLoading = true;

            var searchText = vm.domain.identityPrefix + find;

            return userService.searchIdentities(searchText, type, vm.userStatusFilter).then(result => {
                if (vm.filterIdStrings) {
                    var filterIdStrings = typeof (vm.filterIdStrings) === 'object' ? vm.filterIdStrings : [vm.filterIdStrings];
                    result = _.filter(result, item => { return _.find(filterIdStrings, filter => { return filter == item.idString; }) ? false : true; });
                }

                vm.isLoading = false;

                return _.first(result, 20);
            });
        }

        function setUserStatusFilter(filter) {
            vm.userStatusFilter = filter;
        }
    }
})();